/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

const Instagram = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      fill="none"
      viewBox="0 0 31 31"
      className={className}
    >
      <path
        fill="#fff"
        d="M15.504 7.55a7.934 7.934 0 00-7.947 7.946 7.934 7.934 0 007.947 7.947 7.934 7.934 0 007.946-7.947 7.934 7.934 0 00-7.946-7.946zm0 13.113a5.175 5.175 0 01-5.167-5.167 5.171 5.171 0 015.167-5.165 5.17 5.17 0 015.165 5.165 5.175 5.175 0 01-5.165 5.167zM25.628 7.225a1.85 1.85 0 01-1.853 1.854 1.854 1.854 0 111.854-1.853zm5.263 1.881c-.117-2.482-.685-4.682-2.503-6.494C26.576.801 24.376.233 21.894.11c-2.56-.145-10.229-.145-12.788 0-2.475.117-4.675.685-6.494 2.497C.794 4.417.233 6.616.11 9.099c-.145 2.56-.145 10.229 0 12.788.117 2.482.685 4.682 2.503 6.494 1.82 1.812 4.012 2.379 6.494 2.503 2.56.145 10.229.145 12.788 0 2.482-.117 4.682-.684 6.494-2.503 1.811-1.812 2.379-4.012 2.503-6.494.145-2.56.145-10.222 0-12.78zm-3.306 15.526a5.23 5.23 0 01-2.946 2.946c-2.04.81-6.881.623-9.135.623-2.255 0-7.103.18-9.136-.623a5.23 5.23 0 01-2.946-2.946c-.81-2.04-.623-6.88-.623-9.136 0-2.254-.18-7.102.623-9.135a5.23 5.23 0 012.946-2.946c2.04-.81 6.88-.623 9.136-.623 2.254 0 7.102-.18 9.135.623a5.23 5.23 0 012.946 2.946c.81 2.04.623 6.881.623 9.136 0 2.254.187 7.102-.623 9.135z"
      ></path>
    </svg>
  )
}

Instagram.propTypes = {
  className: PropTypes.string,
}

export default Instagram
